import { render, staticRenderFns } from "./FormContactBank.vue?vue&type=template&id=9020295a&"
import script from "./FormContactBank.vue?vue&type=script&lang=ts&"
export * from "./FormContactBank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9020295a')) {
      api.createRecord('9020295a', component.options)
    } else {
      api.reload('9020295a', component.options)
    }
    module.hot.accept("./FormContactBank.vue?vue&type=template&id=9020295a&", function () {
      api.rerender('9020295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactBank.vue"
export default component.exports